const roleOrdering = {
  billing_manager: 3,
  billing: 3,
  manager: 3,
  member: 3,
  collaborator: 2,
  guest: 1
};

const sortableName = (user: {
  display_name?: string | null;
  email?: string | null;
}) => (user.display_name || user.email || '').toLowerCase();

export default (users, sort: 'name' | 'active') => {
  const sorted = users.concat([]).sort((a, b) => {
    if (sort === 'name') {
      if (a.role && b.role) {
        if (roleOrdering[a.role] > roleOrdering[b.role]) {
          return -1;
        }
        if (roleOrdering[a.role] < roleOrdering[b.role]) {
          return 1;
        }
      }

      const aDisplayName = sortableName(a);
      const bDisplayName = sortableName(b);
      if (aDisplayName < bDisplayName) {
        return -1;
      }
      if (aDisplayName > bDisplayName) {
        return 1;
      }
      return 0;
    } else if (sort === 'active') {
      if (!a.last_active_at && !b.last_active_at) return 0;
      if (!a.last_active_at) return 1;
      if (!b.last_active_at) return -1;

      return (
        new Date(b.last_active_at).getTime() -
        new Date(a.last_active_at).getTime()
      );
    }
    return 0;
  });

  return sorted;
};
